import servicesConfig, { CustomAxiosHeaders } from '../config/services'
import { requests } from '.'
import { AxiosResponse } from 'axios'

export interface WebshotPayload {
    url: string,
    storagePath: string,
    bucketName?: string,
    width?: number,
    height?: number,
    fullPage?: boolean,
}

// Configure request setup
const serviceName = 'WebshotService'
const host = servicesConfig.WebshotService
const opts: CustomAxiosHeaders = { host, serviceName }
const request = (addlOpts?: CustomAxiosHeaders) => {
  return requests(Object.assign({}, opts, addlOpts))
}

// Helper function to handle response
const responseBody = (res: AxiosResponse) => res.data

// Define service object with methods
const WebshotService = {
  screenshot: (payload: WebshotPayload) => 
    request().post(`/screenshot`, payload).then(responseBody)
}

export default WebshotService